import { MessageCircle } from "lucide-react";
import { BRAND } from "../data/site";

export default function WhatsAppFloat() {
  const text = encodeURIComponent("Hi Zyvora Digital, I'd like to get a free consultation for my business.");
  const href = `https://wa.me/${BRAND.whatsappNumber}?text=${text}`;
  return (
    <a
      data-testid="floating-whatsapp-button"
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-green-500 animate-wa-pulse" aria-hidden />
      <span className="relative flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white pl-4 pr-5 py-3 rounded-full shadow-xl transition-all group-hover:translate-y-[-2px]">
        <MessageCircle className="h-5 w-5" />
        <span className="hidden sm:inline font-semibold text-sm">Chat with us</span>
      </span>
    </a>
  );
}
